import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { MERCHANT_TICKETS, USER_TICKET_REPLY, USER_TICKETS, MERCHANT_TICKET_REPLY } from '../../utils/apiUrl';
// utils
import { adminApi, authApi } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: null,
  contacts: { byId: {}, allIds: [] },
  conversations: { byId: {}, allIds: [] },
  activeConversationId: null,
  participants: [],
  recipients: [],
  activeType: ''
};

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CONTACT SSUCCESS
    getContactsSuccess(state, action) {
      const contacts = action.payload;

      state.contacts.byId = objFromArray(contacts);
      state.contacts.allIds = Object.keys(state.contacts.byId);
    },

    // GET CONVERSATIONS
    getConversationsSuccess(state, action) {
      const conversations = action.payload;

      state.conversations.byId = objFromArray(conversations);
      state.conversations.allIds = Object.keys(state.conversations.byId);
      state.isLoading = false;
    },

    // GET CONVERSATION
    getConversationSuccess(state, action) {
      const conversation = action.payload;
      state.isLoading = false;
      if (conversation) {
        state.conversations.byId[conversation.id] = conversation;
        state.activeConversationId = `${conversation.id}`;
        if (!state.conversations.allIds.includes(`${conversation.id}`)) {
          state.conversations.allIds.push(conversation.id);
        }
      } else {
        state.activeConversationId = null;
      }
      console.log('ocneowknwc', state)
    },

    // ON SEND MESSAGE
    // onSendMessage(state, action) {
    //   const conversation = action.payload;
    //   const { conversationId, messageId, message, contentType, attachments, createdAt, senderId } = conversation;

    //   const newMessage = {
    //     id: messageId,
    //     body: message,
    //     contentType,
    //     attachments,
    //     createdAt,
    //     senderId,
    //   };

    //   state.conversations.byId[conversationId].messages.push(newMessage);
    // },

    markConversationAsReadSuccess(state, action) {
      const { conversationId } = action.payload;
      const conversation = state.conversations.byId[conversationId];
      if (conversation) {
        conversation.unreadCount = 0;
      }
    },

    // GET PARTICIPANTS
    getParticipantsSuccess(state, action) {
      const participants = action.payload;
      state.participants = participants;
    },

    // RESET ACTIVE CONVERSATION
    resetActiveConversation(state) {
      state.activeConversationId = null;
    },

    // RESET ACTIVE CONVERSATION
    setActiveConversation(state, action) {
      state.activeConversationId = action.payload;
    },

    addRecipients(state, action) {
      const recipients = action.payload;
      state.recipients = recipients;
    },
    setType(state, action) {
      state.activeType = action.payload
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { addRecipients, resetActiveConversation, setType } = slice.actions;

// ----------------------------------------------------------------------

export function getContacts() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/contacts');
      dispatch(slice.actions.getContactsSuccess(response.data.contacts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getConversations() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/conversations');
      dispatch(slice.actions.getConversationsSuccess(response.data.conversations));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUserTickets() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await adminApi.get(USER_TICKETS);
      dispatch(slice.actions.getConversationsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function onSendMessage(requestData, type) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await adminApi.post(type === 'merchant' ? MERCHANT_TICKET_REPLY : USER_TICKET_REPLY, requestData);
      dispatch(getUserTicketConversation(requestData.ticket, type))
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function onStatusUpdate(requestData, type, conversationKey) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await adminApi.patch(`${type === 'merchant' ? MERCHANT_TICKETS : USER_TICKETS}${conversationKey}/`, requestData);
      dispatch(getUserTicketConversation(conversationKey, type))
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getMerchantTickets() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await adminApi.get(MERCHANT_TICKETS);
      console.log('haxasxasxasxre', response.data.results)
      dispatch(slice.actions.getConversationsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUserTicketConversation(conversationKey, type) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await adminApi.get(`${type === 'merchant' ? MERCHANT_TICKETS : USER_TICKETS}${conversationKey}/`);
      dispatch(slice.actions.getConversationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getConversation(conversationKey) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/conversation', {
        params: { conversationKey },
      });
      dispatch(slice.actions.getConversationSuccess(response.data.conversation));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function markConversationAsRead(conversationId) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.get('/api/chat/conversation/mark-as-seen', {
        params: { conversationId },
      });
      dispatch(slice.actions.markConversationAsReadSuccess({ conversationId }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getParticipants(conversationKey) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/participants', {
        params: { conversationKey },
      });
      dispatch(slice.actions.getParticipantsSuccess(response.data.participants));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setActiveConversation(conversationId) {
  return async () => {
    dispatch(slice.actions.setActiveConversation(conversationId));
  }
}